import {
  DisabledEditabilitySettings,
  ImageItemEditabilitySettings,
  TextItemEditabilitySettings,
} from '../common/constants'

const PlaceholderItemEdibilitySettings = {
  stylable: false,
  resizable: false,
  editable: true,
  locked: false,
  hoverable: false,
  selectable: true,
  draggable: false,
  droppable: false,
  highlightable: false,
  copyable: false,
  badgable: false,
  removable: false,
}

const HOME_CLASSIC_FRAMES = [
  {
    component: {
      type: 'wrapper',
      ...DisabledEditabilitySettings,
      stylable: [
        'background',
        'background-color',
        'background-image',
        'background-repeat',
        'background-attachment',
        'background-position',
        'background-size',
      ],
      components: [
        {
          tagName: 'fullscreen',
          type: 'FullScreen',
          ...DisabledEditabilitySettings,
          components: [
            {
              tagName: 'div',
              type: 'FullScreen',
              ...DisabledEditabilitySettings,
              classes: ['editor-editable-comp-fullscreen'],
              components: [
                {
                  tagName: 'custompagelayout',
                  type: 'CustomPageLayout',
                  ...DisabledEditabilitySettings,
                  components: [
                    {
                      tagName: 'defaultcoverpage',
                      type: 'DefaultCoverPage',
                      ...DisabledEditabilitySettings,
                      components: [
                        {
                          classes: ['cover-page__container', 'proposal-background'],
                          ...DisabledEditabilitySettings,
                          components: [
                            {
                              type: 'image',
                              ...ImageItemEditabilitySettings,
                              classes: ['cover-page__image'],
                              attributes: {
                                alt: 'house-cover',
                                src: '/house-cover.webp',
                                loading: 'lazy',
                              },
                            },
                            {
                              classes: ['cover-page__texts'],
                              ...DisabledEditabilitySettings,
                              components: [
                                {
                                  classes: ['cover-page__logo-wrapper'],
                                  ...DisabledEditabilitySettings,
                                  components: [
                                    {
                                      tagName: 'orglogoblock',
                                      type: 'OrgLogoBlock',
                                      ...DisabledEditabilitySettings,
                                    },
                                  ],
                                },
                                {
                                  classes: ['cover-page__text-container'],
                                  ...DisabledEditabilitySettings,
                                  components: [
                                    {
                                      tagName: 'p',
                                      type: 'text',
                                      ...TextItemEditabilitySettings,
                                      classes: ['cover-page__title'],
                                      style: {
                                        color: '#13171a',
                                        'font-size': '32px',
                                        'font-weight': 'bold',
                                        'letter-spacing': '-0.02em',
                                        'line-height': '56px',
                                        'text-align': 'center',
                                      },
                                      components: [
                                        {
                                          type: 'textnode',
                                          content: 'Your Quote',
                                        },
                                      ],
                                    },
                                    {
                                      tagName: 'placeholder',
                                      type: 'placeholder',
                                      ...PlaceholderItemEdibilitySettings,
                                      classes: ['cover-page__address'],
                                      style: {
                                        color: '#62686e',
                                        'font-size': '20px',
                                        'font-weight': 'normal',
                                        'letter-spacing': '-0.02em',
                                        'line-height': '28px',
                                        'text-align': 'center',
                                      },
                                      attributes: {
                                        'data-placeholder': 'project.address',
                                        PLACEHOLDER_LABEL_OVERRIDE: '',
                                        id: 'home-classic-address',
                                      },
                                      component: {
                                        compare: null,
                                      },
                                    },
                                  ],
                                },
                                {
                                  classes: ['cover-page__text-container'],
                                  ...DisabledEditabilitySettings,
                                  components: [
                                    {
                                      classes: ['cover-page__pro-info'],
                                      ...DisabledEditabilitySettings,
                                      components: [
                                        {
                                          tagName: 'p',
                                          type: 'text',
                                          ...TextItemEditabilitySettings,
                                          style: {
                                            color: '#000',
                                            'font-size': '16px',
                                            'font-weight': 'normal',
                                            'letter-spacing': '-0.02em',
                                            'line-height': '20px',
                                            'text-align': 'center',
                                          },
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: 'Your solar pro: ',
                                            },
                                            {
                                              tagName: 'placeholder',
                                              type: 'placeholder',
                                              ...PlaceholderItemEdibilitySettings,
                                              classes: ['cover-page__pro-info__placeholder'],
                                              style: {
                                                color: '#000',
                                                'font-size': '16px',
                                                'font-weight': 'normal',
                                                'letter-spacing': '-0.02em',
                                                'line-height': '20px',
                                              },
                                              attributes: {
                                                'data-placeholder': 'org.name',
                                                PLACEHOLDER_LABEL_OVERRIDE: '',
                                                id: 'home-classic-org-name',
                                              },
                                              component: {
                                                compare: null,
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          tagName: 'span',
                                          type: 'text',
                                          classes: ['cover-page__pro-info__divider'],
                                          ...DisabledEditabilitySettings,
                                          style: { color: '#d8dde3' },
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: '|',
                                            },
                                          ],
                                        },
                                        {
                                          tagName: 'placeholder',
                                          type: 'placeholder',
                                          ...PlaceholderItemEdibilitySettings,
                                          classes: ['cover-page__pro-info', 'cover-page__pro-info__placeholder'],
                                          style: {
                                            color: '#000',
                                            'font-size': '16px',
                                            'font-weight': 'normal',
                                            'letter-spacing': '-0.02em',
                                            'line-height': '20px',
                                          },
                                          attributes: {
                                            'data-placeholder': 'org.sales_phone_number',
                                            PLACEHOLDER_LABEL_OVERRIDE: '',
                                            id: 'home-classic-sales-phone',
                                          },
                                          component: {
                                            compare: null,
                                          },
                                        },
                                        {
                                          tagName: 'span',
                                          type: 'text',
                                          ...DisabledEditabilitySettings,
                                          classes: ['cover-page__pro-info__divider'],
                                          style: { color: '#d8dde3' },
                                          components: [
                                            {
                                              type: 'textnode',
                                              content: '|',
                                            },
                                          ],
                                        },
                                        {
                                          tagName: 'placeholder',
                                          type: 'placeholder',
                                          ...PlaceholderItemEdibilitySettings,
                                          classes: [
                                            'cover-page__pro-info',
                                            'cover-page__pro-info__placeholder',
                                            'cover-page__pro-info__placeholder__email',
                                          ],
                                          style: {
                                            color: '#000',
                                            'font-size': '16px',
                                            'font-weight': 'bold',
                                            'letter-spacing': '-0.02em',
                                            'line-height': '20px',
                                          },
                                          attributes: {
                                            'data-placeholder': 'org.company_email',
                                            PLACEHOLDER_LABEL_OVERRIDE: '',
                                            id: 'home-classic-org-email',
                                          },
                                          component: {
                                            compare: null,
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      type: 'div',
                                      classes: ['cover-page__date__container'],
                                      ...DisabledEditabilitySettings,
                                      components: [
                                        {
                                          tagName: 'span',
                                          type: 'text',
                                          ...TextItemEditabilitySettings,
                                          classes: ['cover-page__date__label'],
                                          style: {
                                            color: '#929aa1',
                                            'font-size': '16px',
                                            'font-weight': 'normal',
                                            'letter-spacing': '-0.02em',
                                            'line-height': '20px',
                                          },
                                          content: 'Created',
                                        },
                                        {
                                          tagName: 'placeholder',
                                          type: 'placeholder',
                                          ...PlaceholderItemEdibilitySettings,
                                          classes: ['cover-page__date'],
                                          style: {
                                            color: '#929aa1',
                                            'font-size': '16px',
                                            'font-weight': 'normal',
                                            'letter-spacing': '-0.02em',
                                            'line-height': '20px',
                                            'text-align': 'center',
                                          },
                                          attributes: {
                                            'data-placeholder': 'project.created_date',
                                            PLACEHOLDER_LABEL_OVERRIDE: '',
                                            id: 'home-classic-created-date',
                                          },
                                          component: {
                                            compare: null,
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'textnode',
                  content: '\n',
                },
              ],
            },
          ],
        },
      ],
      head: {
        type: 'head',
      },
      docEl: {
        tagName: 'html',
      },
    },
    id: 'home-classic-frame-001',
  },
]

export const HOME_CLASSIC_PAGE_ID = 'custom_home-classic'

export const HOME_CLASSIC_PAGE_DESIGN = {
  frames: HOME_CLASSIC_FRAMES,
  name: 'Cover Page Style 1',
  id: HOME_CLASSIC_PAGE_ID,
  type: 'main',
}
